__turbopack_context__.v({
  "buttonIcon": "GenericCTA-module-scss-module__4v7b_G__buttonIcon",
  "ctaButton": "GenericCTA-module-scss-module__4v7b_G__ctaButton",
  "dark-gray": "GenericCTA-module-scss-module__4v7b_G__dark-gray",
  "red": "GenericCTA-module-scss-module__4v7b_G__red",
  "red-outline": "GenericCTA-module-scss-module__4v7b_G__red-outline",
});
